import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect, withDefaults } from "vue";
import { INITIAL_VIDEO_DURATION, PLAYBACK_RATES } from "../constants";
import { convertSecondsToTimeFormat } from "../utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaControlPanel',
  props: {
    isPaused: { type: Boolean },
    mediaCurrentTime: { default: INITIAL_VIDEO_DURATION },
    totalMediaTime: { default: INITIAL_VIDEO_DURATION },
    volume: { default: 0 },
    playBackSpeed: null
  },
  emits: ["onPlayControl", "onUpdateCurrentTime", "onUpdateVolume", "onUpdateSpeed"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "onPlayControl"): void;
  (e: "onUpdateCurrentTime", value?: number, isTimeIncrement?: boolean): void;
  (e: "onUpdateVolume", value: number): void;
  (e: "onUpdateSpeed", value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isPaused: boolean, mediaCurrentTime: number, totalMediaTime: number, volume: number, playBackSpeed: number };

const jumpDuration = 10;
const mediaMinimumVolume = 0;
const mediaMaximumVolume = 1;
const mediaVolumeJumpStep = 0.01;
const minimumMediaDurationPercentage = 0;
const maximumMediaDurationPercentage = 100;
const controlIconSize = 32;





const currentTime = ref();
const isMediaPaused = ref();
const mediaVolume = ref(mediaMinimumVolume);
const totalMediaTime = ref(INITIAL_VIDEO_DURATION);
const currentSpeedIndex = ref();
const currentTimePercent = ref(minimumMediaDurationPercentage);
const sliderAnimationID = ref(minimumMediaDurationPercentage);

const updateTime = () => {
  currentTimePercent.value =
    (props.mediaCurrentTime / props.totalMediaTime) * 100 ||
    minimumMediaDurationPercentage;
  sliderAnimationID.value = requestAnimationFrame(updateTime);
}

watchEffect(() => {
  currentTime.value = props.mediaCurrentTime;
  isMediaPaused.value = props.isPaused;
  mediaVolume.value = props.volume;
  totalMediaTime.value = props.totalMediaTime;
  currentSpeedIndex.value = PLAYBACK_RATES.findIndex(
    (speed) => speed.value === props.playBackSpeed
  );

  if (isMediaPaused.value) {
    currentTimePercent.value =
      (props.mediaCurrentTime / props.totalMediaTime) * 100 ||
      minimumMediaDurationPercentage;
    cancelAnimationFrame(sliderAnimationID.value);
  } else {
    sliderAnimationID.value = requestAnimationFrame(updateTime);
  }
});

const togglePlayAndPause = () => {
  emits("onPlayControl");
};

const onForward = () => {
  emits("onUpdateCurrentTime", jumpDuration);
};

const onBackward = () => {
  emits("onUpdateCurrentTime", -jumpDuration);
};

const onUpdateSpeed = () => {
  if (currentSpeedIndex.value < PLAYBACK_RATES.length - 1) {
    currentSpeedIndex.value += 1;
  } else {
    currentSpeedIndex.value = 0;
  }
  emits("onUpdateSpeed", PLAYBACK_RATES[currentSpeedIndex.value].value);
};

const onScrollEnd = async(timePercent: number) => {
  const updatedTime = props.totalMediaTime * timePercent / 100;
  emits("onUpdateCurrentTime", updatedTime, false);
  emits("onPlayControl");
}

const onScrollStart = () => {
  emits("onPlayControl");
}

const updateVolumeOnSeek = (volume: number) => {
  emits("onUpdateVolume", volume);
};

return { __sfc: true,jumpDuration, mediaMinimumVolume, mediaMaximumVolume, mediaVolumeJumpStep, minimumMediaDurationPercentage, maximumMediaDurationPercentage, controlIconSize, props, emits, currentTime, isMediaPaused, mediaVolume, totalMediaTime, currentSpeedIndex, currentTimePercent, sliderAnimationID, updateTime, togglePlayAndPause, onForward, onBackward, onUpdateSpeed, onScrollEnd, onScrollStart, updateVolumeOnSeek, PLAYBACK_RATES, convertSecondsToTimeFormat }
}

})